import Cookies from 'js-cookie'
import $ from 'jquery';

$( document ).ready(function() {
    let limit = Cookies.get($('.results_limit').attr('id')) || 10;
    $('#current_limit').text(limit);

    $(".dropdown-menu").on('click', ".js-limit", function () {
        Cookies.set($(this).parent('.dropdown-menu').attr('id'), $(this).data('limit'), {expires: 365, samesSite: 'Lax'});
        window.location.reload();
    });

    $('.js-page-input')
        .on('keydown', function (e) {
            if (e.which === 13) {
                e.preventDefault();
                let page = Number(e.target.value);
                const href = new URL(window.location.href);
                if (isNaN(page)) {
                    page = href.searchParams.get("page", page) || 1;
                    href.searchParams.set("page", page);
                    window.location.href = href.toString();
                    return;
                }

                href.searchParams.set("page", page);
                window.location.href = href.toString();
            }
        })

    $('.results_limit')
        .val(limit)
        .change()
        .on('change', function (event) {
            Cookies.set($(this).attr('id'), event.target.value, {expires: 365, samesSite: 'Lax'} );

            let r = new URL(window.location.href );
            r.searchParams.delete('page');
            let href = r.href;

            location.href = href;
    });

    $.extend(
        $.expr[':'].containsCI = function (a, i, m) {
            var sText = (a.textContent || a.innerText || "");
            var zRegExp = new RegExp(m[3], 'i');

            return zRegExp.test(sText);
        }
    );

});